export default {
  UNKNOWN: 1,
  INVOICE: 2,
  PENDING_DIVISION_ORDER: 3,
  RUN_STATEMENT: 4,
  DOCUMENT_1099: 5,
  OWNER_STATEMENT: 6,
  SUSPENSE_REPORT: 7,
  DIVISION_OF_INTEREST: 8,
  SUMMARY_BY_DISTRIBUTION_REPORT: 9,
  OUTSIDE_OPERATOR_EXPENSE_REPORT: 10,
};
